<div [formGroup]="form">
  <!-- País -->
  <mat-form-field *ngIf="country" appearance="fill" class="w-full">
    <mat-label>País</mat-label>
    <mat-select 
      formControlName="locationOneIds" 
      placeholder="Seleccione países" 
      [multiple]="multiCountry">
      <mat-select-trigger>
        {{ getDisplayValue(countryList, form.get('locationOneIds')?.value, 'name') }}
      </mat-select-trigger>

      <!-- Estado de carga -->
      <mat-option *ngIf="loadingCountries" disabled>
        <span class="flex items-center gap-2">
          <span class="animate-spin">⟳</span>
          Cargando países...
        </span>
      </mat-option>

      <!-- Buscador -->
      <mat-option *ngIf="!loadingCountries && countryList?.length">
        <ngx-mat-select-search 
          [(ngModel)]="searchCountry" 
          [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar país..." 
          noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterCountry($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- Opciones -->
      <mat-option 
        *ngFor="let country of filteredCountryList" 
        [value]="country._id">
        <div class="text-sm uppercase leading-tight">
          <div>
            <b class="f-9" *ngIf="getCode(country) as code">{{ code }}</b>
          </div>
          {{ country.name }}
        </div>
      </mat-option>

      <!-- Estado vacío -->
      <mat-option *ngIf="!loadingCountries && !countryList?.length" disabled>
        No hay países disponibles
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Departamento -->
  <mat-form-field *ngIf="department" appearance="fill" class="w-full">
    <mat-label>Departamento</mat-label>
    <mat-select 
      formControlName="locationTwoIds" 
      placeholder="Seleccione departamentos" 
      [multiple]="multiDepartment">
      <mat-select-trigger>
        {{ getDisplayValue(departmentList, form.get('locationTwoIds')?.value, 'name') }}
      </mat-select-trigger>

      <!-- Estado de carga -->
      <mat-option *ngIf="loadingDepartments" disabled>
        <span class="flex items-center gap-2">
          <span class="animate-spin">⟳</span>
          Cargando departamentos...
        </span>
      </mat-option>

      <!-- Buscador -->
      <mat-option *ngIf="!loadingDepartments && departmentList?.length">
        <ngx-mat-select-search 
          [(ngModel)]="searchDepartment" 
          [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar departamento..." 
          noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterDepartment($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- Opciones -->
      <mat-option 
        *ngFor="let department of filteredDepartmentList" 
        [value]="department._id">
        <div class="text-sm uppercase leading-tight">
          <div>
            <b class="f-9" *ngIf="getCode(department) as code">{{ code }}</b>
          </div>
          {{ department.name }}
        </div>
      </mat-option>

      <!-- Estados vacíos/deshabilitado -->
      <mat-option *ngIf="!loadingDepartments && !departmentList?.length && (!form.get('locationOneIds')?.value || form.get('locationOneIds')?.value.length === 0)" disabled>
        Seleccione primero un país
      </mat-option>
      <mat-option *ngIf="!loadingDepartments && !departmentList?.length && form.get('locationOneIds')?.value && form.get('locationOneIds')?.value.length > 0" disabled>
        No hay departamentos disponibles
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Ciudad -->
  <mat-form-field *ngIf="city" appearance="fill" class="w-full">
    <mat-label>Ciudad</mat-label>
    <mat-select 
      formControlName="locationThreeIds" 
      placeholder="Seleccione ciudades" 
      [multiple]="multiCity">
      <mat-select-trigger>
        {{ getDisplayValue(cityList, form.get('locationThreeIds')?.value, 'name') }}
      </mat-select-trigger>

      <!-- Estado de carga -->
      <mat-option *ngIf="loadingCities" disabled>
        <span class="flex items-center gap-2">
          <span class="animate-spin">⟳</span>
          Cargando ciudades...
        </span>
      </mat-option>

      <!-- Buscador -->
      <mat-option *ngIf="!loadingCities && cityList?.length">
        <ngx-mat-select-search 
          [(ngModel)]="searchCity" 
          [ngModelOptions]="{ standalone: true }"
          placeholderLabel="Buscar ciudad..." 
          noEntriesFoundLabel="No se encontraron resultados"
          (ngModelChange)="filterCity($event)">
        </ngx-mat-select-search>
      </mat-option>

      <!-- Opciones -->
      <mat-option 
        *ngFor="let city of filteredCityList" 
        [value]="city._id">
        <div class="text-sm uppercase leading-tight">
          <div>
            <b class="f-9" *ngIf="getCode(city) as code">{{ code }}</b>
          </div>
          {{ city.name }}
        </div>
      </mat-option>

      <!-- Estados vacíos/deshabilitado -->
      <mat-option *ngIf="!loadingCities && !cityList?.length && (!form.get('locationTwoIds')?.value || form.get('locationTwoIds')?.value.length === 0)" disabled>
        Seleccione primero un departamento
      </mat-option>
      <mat-option *ngIf="!loadingCities && !cityList?.length && form.get('locationTwoIds')?.value && form.get('locationTwoIds')?.value.length > 0" disabled>
        No hay ciudades disponibles
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>